import { InfoRounded } from '@mui/icons-material'
import classNames from 'classnames'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { removeModalScrollSafari } from 'helpers/removeModalScrollSafari'
import { useEffect, useState } from 'react'
import { Modal, Button } from 'ui'

import { ModalHow } from '../howWork/ModalHow'

import { ModalDownload } from './ModalDownload/ModalDownload'
import style from './InfBlock.module.scss'

// кнопки для открытия информационных окон
export function InfBlock() {
  const [isOpenConsultModal, setIsHowOpen] = useState(false)
  const [isDownloadOpen, setIsDownloadOpen] = useState(false)

  const handleIsHowOpen = () => {
    removeModalScrollSafari(true)
    setIsHowOpen(true)
  }

  const handleIsHowClose = () => {
    removeModalScrollSafari(false)
    setIsHowOpen(false)
  }

  const handleDownloadOpen = () => {
    removeModalScrollSafari(true)
    setIsDownloadOpen(true)
  }

  const handleDownloadClose = () => {
    removeModalScrollSafari(false)
    setIsDownloadOpen(false)
  }

  const screen = useScreen()

  useEffect(() => {
    if (screen !== ScreenEnum.mobile) {
      setIsHowOpen(false)
    }
  }, [screen])

  return (
    <section className={style.footerInf}>
      <Button
        className={classNames(
          style.footerInfService,
          'tablet-hidden desktop-hidden',
        )}
        variant='contained'
        color='secondary'
        onClick={handleIsHowOpen}
        startIcon={<InfoRounded className='c-primary' />}
        data-testid='inf-how-to-btn'
      >
        <span>Как работать с сервисом</span>
      </Button>

      <div className={style.footerInfReviews}>
        <Button
          variant='contained'
          size='large'
          onClick={handleDownloadOpen}
          data-testid='inf-download-btn'
        >
          Скачать приложение «Мой DoorHan»
        </Button>
      </div>

      <Modal open={isOpenConsultModal} onClose={handleIsHowClose}>
        <ModalHow close={handleIsHowClose} />
      </Modal>

      <ModalDownload open={isDownloadOpen} onClose={handleDownloadClose} />
    </section>
  )
}
